var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseBox',[(_vm.resource)?_c('BaseText',[_c('i18n',{attrs:{"tag":false,"path":"message"}}),_vm._v(" "+_vm._s(_vm.$t('message', { resource: _vm.resource }))+" ")],1):_c('BaseText',[_c('i18n',{attrs:{"tag":false,"path":"title"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }